var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxBackpackOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30759 4.61548H9.69231C10.1412 4.61548 10.5716 4.79377 10.889 5.11115C11.2064 5.42852 11.3847 5.85896 11.3847 6.30779V13.5001H4.61523V6.30779C4.61523 5.85896 4.79353 5.42852 5.11092 5.11115C5.42829 4.79377 5.85875 4.61548 6.30759 4.61548Z",
    stroke: "CurrentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61545 13.5006H2.5V10.1159C2.5 9.89151 2.58915 9.67629 2.74784 9.51761C2.90653 9.35893 3.12176 9.26978 3.34618 9.26978H4.61545",
    stroke: "CurrentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3848 9.26978H12.654C12.8784 9.26978 13.0937 9.35893 13.2524 9.51761C13.411 9.67629 13.5002 9.89151 13.5002 10.1159V13.5006H11.3848",
    stroke: "CurrentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61523 8.42358H11.3847",
    stroke: "CurrentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.57715V9.26946",
    stroke: "CurrentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30859 4.61539V4.19231C6.30859 3.74349 6.48689 3.31304 6.80428 2.99567C7.12165 2.6783 7.55211 2.5 8.00095 2.5C8.44979 2.5 8.88025 2.6783 9.19763 2.99567C9.51501 3.31304 9.69331 3.74349 9.69331 4.19231V4.61539",
    stroke: "CurrentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxBackpackOutline);
export default __webpack_public_path__ + "static/media/icon_16px_backpack_outline.1b7e5262464755c31bcfbc4b693d6b94.svg";
export { ForwardRef as ReactComponent };